export default "__VITE_ASSET__Do$xHWzI__"